import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const AsyncEventLogList = () => {
  const fetchUrl = `${API_DOMAIN}${API_ROUTES.asyncEventLog}`;

  const columns = [
    { label: 'Event Type', value: 'event_type' },
    { label: 'Processed', value: item => item.processed ? 'Yes' : 'No' },
    { label: 'Processed At', value: (item) => fmtDateTime(item.processed_at) },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/async-event-log/details/${id}`;
  };

  return (
    <div>
      <h1>Async Event Logs</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default AsyncEventLogList;
